module.exports = __webpack_public_path__ + "img/capa2.795ce903.webp";